module.exports = __webpack_public_path__ + "static/media/FamilyRestroomIcon.24758416.svg";